import { useEffect, useState } from "react";
import axiosInstance from "../axiosConfig";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  CircularProgress,
  Grid,
  InputAdornment,
  Paper,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import SearchIcon from "@mui/icons-material/Search";
import ServiceOrderCard from "../Components/ServiceOrderCard";
import SEO from "../Components/SEO";
import { useTranslation } from "react-i18next";

const ServicesGuide = () => {
  const [services, setServices] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [guideExists, setGuideExists] = useState(false);
  const { t } = useTranslation();

  useEffect(() => {
    axiosInstance
      .get("/MunicipalityService/MunicipalityServicesGuide")
      .then((data) => {
        setServices(Array.isArray(data) ? data : []);
      })
      .catch(() => {
        setServices([]);
      })
      .finally(() => {
        setIsLoading(false);
      });

    fetch("/api/MunicipalityService/ServicesGuidePdfInfo")
      .then((r) => r.json())
      .then((d) => setGuideExists(!!d?.exists))
      .catch(() => {});
  }, []);
  if (isLoading) {
    return (
      <Box sx={{ mt: 15, textAlign: "center" }}>
        <CircularProgress size={80} />
      </Box>
    );
  }

  if (!services || services.length === 0) {
    return (
      <Box sx={{ mt: 15, textAlign: "center", p: 5 }}>
        <Typography variant="h5" color="text.secondary" sx={{ mb: 2 }}>
          {t('noServicesAvailable')}
        </Typography>
        <Typography variant="body1" color="text.secondary">
          {t('tryAgainLater')}
        </Typography>
      </Box>
    );
  }

  const filteredServices = services
    .map((svc) => ({
      ...svc,
      publicServices: svc.publicServices.filter((f) =>
        f.name?.toLowerCase().includes(searchQuery.toLowerCase())
      ),
    }))
    .filter((svc) => svc.publicServices.length > 0);

  const isSearching = searchQuery.trim().length > 0;

  return (
    <>
    <SEO title={t('servicesGuide')} />
    <Paper sx={{ p: 3, background: "#F9FAFC" }} elevation={5}>
      <Stack gap={3}>
        {guideExists && (
          <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
            <Button
              variant="contained"
              color="primary"
              startIcon={<DownloadIcon />}
              component="a"
              href="/PublicServiceGuid/services-guide.pdf"
              target="_blank"
              rel="noopener noreferrer"
              download
            >
              {t('downloadServicesGuide', 'تنزيل كتيب الخدمات')}
            </Button>
          </Box>
        )}
        <TextField
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          placeholder="ابحث عن خدمة..."
          variant="outlined"
          fullWidth
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon color="primary" />
              </InputAdornment>
            ),
          }}
          sx={{ backgroundColor: "#fff", borderRadius: 2 }}
        />

        {isSearching && filteredServices.length === 0 && (
          <Box sx={{ textAlign: "center", py: 4 }}>
            <Typography color="text.secondary">
              لا توجد خدمات تطابق "{searchQuery}"
            </Typography>
          </Box>
        )}

        {filteredServices.map((svc) => (
          <Accordion key={svc.name} defaultExpanded={isSearching}>
            <AccordionSummary
              expandIcon={<ArrowDropDownIcon color="primary" />}
            >
              <Typography
                sx={{ fontWeight: "bold" }}
                variant="h6"
                color="primary.main"
              >
                {svc.name}
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Grid spacing={3} container>
                {svc.publicServices.map((f) => (
                  <Grid item lg={4} md={6} xs={12} key={f.name}>
                    <ServiceOrderCard
                      pageName="/service-guide-details"
                      {...f}
                      groupName={svc.name}
                      name={f.name}
                    />
                  </Grid>
                ))}
              </Grid>
            </AccordionDetails>
          </Accordion>
        ))}
      </Stack>
    </Paper>
    </>
  );
};
export default ServicesGuide;
